import { NgModule, Optional, SkipSelf } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ServerNotificationService } from './server-notification.service';
import { throwIfAlreadyLoaded } from '../helpers/module-import-guard';
import { ServerNotificationConfigService } from './server-notification-config.service';
import { SignalrWindow } from './service-notification.interfaces';

@NgModule({
  imports: [
    CommonModule
  ],
  declarations: [],
  providers: [
    ServerNotificationConfigService,
    ServerNotificationService
  ]
})
export class ServerNotificationModule {
  constructor( @Optional() @SkipSelf() parentModule: ServerNotificationModule) {
    throwIfAlreadyLoaded(parentModule, 'ServerNotificationModule');
  }
}



// WEBPACK FOOTER //
// /home/runner/work/cdg-missioncontrol/cdg-missioncontrol/MissionControlClient2/MissionControl.WebUi2/mc-app/src/app/core/server-notification/server-notification.module.ts